// extracted by mini-css-extract-plugin
export default {"scrolltoTop":"ScrollToTop_scrolltoTop__JHM+K","fadeIn":"ScrollToTop_fadeIn__l2pqM"};